import {ChatRegularOptionsIcon} from 'shells/icon';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {CollapsibleStatBreakdown} from 'shells/metrics/collapsible-stat-breakdown/collapsible-stat-breakdown';

import {useGetAudienceSmsMembershipStats} from '../graphql/hooks/use-get-audience-sms-membership-stats';
type Props = {
    audienceId: string;
    isCollapsed: boolean;
    showChevron?: boolean | null | undefined;
};

export function CollapsibleSmsStats(props: Props) {
    const {smsMembershipStats, isLoading} = useGetAudienceSmsMembershipStats(props.audienceId);

    if (isLoading || !smsMembershipStats) {
        return (
            <div className='pad-16 full-width border-box'>
                <LoadingPage fullHeight={true} />
            </div>
        );
    }

    const excludedCount = smsMembershipStats.totalCount.value - smsMembershipStats.subscribedCount;

    return (
        <CollapsibleStatBreakdown
            isCollapsed={props.isCollapsed}
            icon={ChatRegularOptionsIcon}
            title='SMS subscribers'
            value={smsMembershipStats.subscribedCount}
            showChevron={props.showChevron || false}
            statsBreakdown={{
                header: `Reasons ${excludedCount.toLocaleString()} out of ${smsMembershipStats.totalCount.value.toLocaleString()} were excluded`,
                details: [
                    {
                        label: 'Duplicate phone number',
                        value: smsMembershipStats.duplicatePhoneNumberCount,
                    },
                    {
                        label: 'Missing phone number',
                        value: smsMembershipStats.missingPhoneNumberCount,
                    },
                    {
                        label: 'Undeliverable',
                        value: smsMembershipStats.undeliverableCount,
                    },
                    {
                        label: 'Opted out',
                        value: smsMembershipStats.optedOutCount,
                    },
                ],
            }}
            shouldExcludeZeroes={true}
        />
    );
}
